module.exports = __webpack_public_path__ + "img/ec2.0c03c06a.svg";